<template>
  <div class="location">
    <label v-if="title">{{title}}</label>
    <select v-model="val" @change="change">
      <option v-for="(option, key) in items" :key="key" :value="key">
        {{ option }}
      </option>
    </select>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  // name: "NotificationSelect",
  data() {
    return{  }
  },
  props: {
    value: {
      default: null,
    },
    title: {
      default: null,
    },
    items: {
      default: [
        'Всем',
        'Родителям',
        'Ученикам',
      ],
    },
  },
  created() {
    this.val = 0;
  },
  mounted(){
    // this.value = 0
    
  },
  methods: {
    change(e) {},
  },
  computed: {
    // ...mapState(["courses"]),
    val: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
<style lang="scss">
.location {
  select {
    padding: 5px 5px;
    width: 100%;
    height: 34px;
    border-radius: 10px;
    margin-bottom: 15px;
  }
}
</style>
